import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from 'reactstrap';

import { ViewAttachment } from 'models/Order';

interface Props {
  attachments: ViewAttachment[];
  downloadAttachment: (id: number, title: string) => void;
}

const OrderFileList: React.FC<Props> = ({ attachments, downloadAttachment }) => {
  const { t } = useTranslation('translation');

  return (
    <>
      <Label>{t('orders.FIELDLABEL_SELECTED_ATTACHMENTS')}</Label>
      <ul>
        {attachments.map((a: ViewAttachment, index: number) => (
          <li key={index}>
            <button
              onClick={(event: any) => {
                event.preventDefault();
                event.stopPropagation();
                downloadAttachment(a.id, a.title);
              }}
            >
              {a.title} <i className="fa fa-file-download remove-attachment-btn"></i>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

export default OrderFileList;
